import React, { FC, useState } from "react";
import Carousel from "react-material-ui-carousel";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Icons, Tooltip, Checkbox } from "@gpstrackit/gtc-react-controls";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import { useIntl } from "react-intl";
import { ConcatLabel } from "Components";


export const CarouselComp = ({
    expandImage,
    item,
    setSelected,
    selected,
    setSelectedFavorite,
    selectedFavorite,
    onClickDelete,
    vhLabel
}) => {

  const { messages } = useIntl();


    const [openImg, setOpenImg] = useState(false);
    const [images, setImages] = useState([]);
    const { driverID, faces } = item;

    const isChecked = selected?.find((sel) => sel?.driverID === driverID);
    const dropItem = () => {
        setSelected &&
            setSelected(
                selected &&
                selected?.filter(
                    (selec) => selec?.driverID !== driverID
                )
            );
    };

    const addItem = () => {
        const newItem = [...selected, { ...item }];
        setSelected && setSelected(newItem);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}>
            <Carousel
                navButtonsAlwaysVisible={faces?.length > 1 ? true : false}
                navButtonsAlwaysInvisible={faces?.length <= 1 ? true : false}
                fullHeightHover={false}
                animation="slide"
                autoPlay={false}
                sx={{ width: "100%", height: "296px" }}>
                {faces?.length > 0 ? 
                    faces?.map(face => {
                        return(
                            <Content
                                expandImage={expandImage}
                                key={face?.faceID}
                                faceId={face?.faceID}
                                url={face?.url}
                                setOpenImg={setOpenImg}
                                onClick={() => setImages(faces)}
                                setSelectedFavorite={setSelectedFavorite}
                                selectedFavorite={selectedFavorite}
                                onClickDelete={onClickDelete && onClickDelete}
                                heigth="270px"
                            />
                        )
                    })
                    :
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '270px'
                    }}>
                        <div style={{
                                color: "#999191",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column"
                        }}>
                            <Icons name="broken_image" />
                            <p>{messages['settingsDriver_driversFacesNoFaceDetected']}</p>
                        </div>
                    </div>
                }
            </Carousel>
            {setSelected && (
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}>
                    <LinkedUnlinked
                        isLinked={item?.tspDriver ? true : false}
                        driverName={item?.driverName}
                        vhLabel={vhLabel}
                    />
                    <Checkbox
                        checked={isChecked}
                        label=""
                        onChange={() => { }}
                        onClick={() => {
                            if (isChecked) {
                                dropItem();
                            } else {
                                addItem();
                            }
                        }}
                    />
                </div>
            )}
            <ModalImg
                openImg={openImg}
                setOpenImg={setOpenImg}
                imgs={images}
                setSelectedFavorite={setSelectedFavorite}
                selectedFavorite={selectedFavorite}
            />
        </div>
    );
};

export const LinkedUnlinked = ({ isLinked, driverName, vhLabel }) => {
    const { messages } = useIntl()
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "600",
                    padding: "15px 15px 0px",
                }}>
                <div
                    style={{
                        color: " rgb(114, 114, 114)",
                        fontSize: "14px",
                        lineHeight: "19px",
                    }}>
                    {messages["settingsDriver_driversFacesAssignedTo"]}:
                </div>
                <div style={{ marginLeft: "10px" }}>
                    {isLinked ? <div><ConcatLabel username={driverName} concatLimit={15}/> </div> : messages["settingsDriver_driversFacesUnlinked"]}
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "600",
                    padding: "5px 15px 0",
                }}>
                <div
                    style={{
                        color: " rgb(114, 114, 114)",
                        fontSize: "14px",
                        lineHeight: "19px",
                        width: '80px',
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                    {messages["fleet_vehicle"]}:
                </div>
                <div style={{ marginLeft: "10px" }}>
                    {vhLabel ? vhLabel : messages["settingsDriver_driversFacesNoVh"]}
                </div>
            </div>
        </div>

    );
};

export const Content = ({
    expandImage,
    url,
    setOpenImg,
    onClick,
    faceId,
    sizeImg,
    setSelectedFavorite,
    selectedFavorite,
    heigth,
    onClickDelete,
}) => {
    const { messages } = useIntl()
    const isFavorite = selectedFavorite === url ? true : false;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}>
            <img
                style={{ width: sizeImg ? sizeImg : "100%", height: heigth }}
                src={url}
                alt={faceId}
            />
            {expandImage && (
                <div
                    style={{
                        position: "absolute",
                        cursor: "pointer",
                        color: "white",
                        fontSize: "50px",
                    }}
                    onClick={() => {
                        onClick && onClick();
                        setOpenImg(true);
                    }}>
                    <Icons size="inherit" name="search" />
                </div>
            )}
            {setSelectedFavorite && (
                <div
                    style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "35px",
                        top: "5px",
                        right: "5px",
                        zIndex: 10,
                    }}
                    onClick={() => {
                        if (isFavorite) {
                            setSelectedFavorite && setSelectedFavorite("");
                        } else {
                            setSelectedFavorite && setSelectedFavorite(url);
                        }
                    }}>
                    <Tooltip
                        placement="left"
                        title={messages["settingsDriver_driversFacesSelectTempUrl"]}>
                        {isFavorite ? (
                            <Icons color="yellow" size="inherit" name="starOutlineRoundedIcon" />
                        ) : (
                            <StarOutlineRoundedIcon
                                fontSize="inherit"
                                sx={{ color: "black" }}
                            />
                        )}
                    </Tooltip>
                </div>
            )}
            {onClickDelete && !setSelectedFavorite && (
                <div
                    style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "35px",
                        top: "5px",
                        right: "5px",
                        zIndex: 10,
                    }}
                    onClick={() => onClickDelete && onClickDelete(faceId)}>

                    <Tooltip
                        placement="left"
                        title={messages["settingsDriver_driversFacesDetele"]}>
                        <DeleteForeverRoundedIcon sx={{ color: "#c63737" }} fontSize="inherit" />
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export const ModalImg = ({
    openImg,
    setOpenImg,
    imgs,
    setSelectedFavorite,
    selectedFavorite,
}) => {
    const handleClose = () => setOpenImg(false);
    return (
        <div>
            <Modal open={openImg} onClose={handleClose}>
                <Box>
                    <div
                        style={{
                            position: "absolute",
                            right: "5px",
                        }}>
                        <Icons
                            size="large"
                            name="close"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClose();
                            }}
                        />
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            left: "50%",
                            transform: "translate(-50%, 0)",
                            width: "60%",
                            top: "15px",
                            bottom: "30px",
                        }}>
                        <Carousel
                            fullHeightHover={false}
                            navButtonsAlwaysVisible={imgs?.length > 1 ? true : false}
                            navButtonsAlwaysInvisible={imgs?.length <= 1 ? true : false}
                            autoPlay={false}
                            animation="slide">
                            {imgs &&
                                imgs?.map((item, i) => (
                                    <Content
                                        // sizeImg="70%"
                                        heigth="95vh"
                                        key={i}
                                        url={item?.url}
                                        setOpenImg={setOpenImg}
                                        setSelectedFavorite={setSelectedFavorite}
                                        selectedFavorite={selectedFavorite}
                                    />
                                ))}
                        </Carousel>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};
